import sortOrder from '#app/utils/templates/utils/sortOrder.ts'
import * as templates from '#app/utils/templates/index.tsx'
import { chainIDMapping } from './misc.tsx'
import {
	MariaDBPinnedMetadataResponse,
	MetadataProperties,
	type PinnedMetadataProperties,
} from '#app/server/db.server'
import {
	CollectionNFTInputType,
	CollectionNFTReference,
	CollectionNFTReferenceKey,
	CollectionNFTReferenceValue,
	SmartConractFullValue,
} from './templates/utils/templateTypes.ts'
export const tempValues = Object.values(templates)
const fieldMapping = {}
const reverseFieldMapping = {}
const selectOptions = []
const metadataTypeMap = {}
// Populate Template Values
tempValues.forEach(item => {
	selectOptions.push(item)
	metadataTypeMap[item.slug] = item.name
	item.fields.forEach(val => {
		fieldMapping[val.name] = val.slug
		reverseFieldMapping[val.slug] = val.name
	})
})

export type AttestationState =
	| 'editing'
	| 'pinning'
	| 'pin error'
	| 'pinned'
	| 'signing'
	| 'sign error'
	| 'signed'

export const fullSelectOptions = selectOptions
export const slugToNameTemplateMapping = metadataTypeMap
export const fullFieldMapping = fieldMapping
export const fullFieldKeyToNameMapping = reverseFieldMapping

export const generatePayloadString = (payload, isOriginal = false) => {
	let string = ``
	const chain = payload.chain
	Object.keys(payload)
		.sort((a, b) => {
			return sortOrder.indexOf(a) - sortOrder.indexOf(b)
		})
		.filter(key => {
			if (payload[key] !== undefined) {
				if (key !== 'web2URL' && key !== 'artistID' && key !== 'artistAvatar') {
					if (payload[key] !== undefined) {
						if (payload[key] !== '') {
							return true
						}
					}
				}
			}
			return false
		})
		.forEach(key => {
			let val = payload[key]
			if (key.indexOf('address') > -1) {
				val = chain === 'solana' ? val : val.toLowerCase()
			} else if (key.indexOf('exhibitionWallet') > -1) {
				val = chain === 'solana' ? val : val.toLowerCase()
			} else if (key.indexOf('lendeeAddress') > -1) {
				val = chain === 'solana' ? val : val.toLowerCase()
			} else if (key.indexOf('lenderAddress') > -1) {
				val = chain === 'solana' ? val : val.toLowerCase()
			} else if (key.indexOf('ownerWallet') > -1) {
				val = chain === 'solana' ? val : val.toLowerCase()
			} else if (key.indexOf('ownerAddress') > -1) {
				val = chain === 'solana' ? val : val.toLowerCase()
			} else if (key.indexOf('receiverAddress') > -1) {
				val = chain === 'solana' ? val : val.toLowerCase()
			} else if (key.indexOf('counterSigningAddress') > -1) {
				val = chain === 'solana' ? val : val.toLowerCase()
			}
			if (key.indexOf('url') > -1 && !isOriginal) {
				string += `- URL: ${val}
        `
			} else if (key.indexOf('ipfsCID') > -1 && !isOriginal) {
				string += `- IPFS URL: ${val}
        `
			} else if (key.indexOf('arweaveTxId') > -1 && !isOriginal) {
				string += `- Arweave URL: ${val}
        `
			} else if (key.indexOf('nfts') > -1 && !isOriginal) {
				console.log('DONT ADD NFTS')
			} else {
				string += `- ${reverseFieldMapping[key]}: ${val}
        `
			}
		})
	return string
}

export const generateRollupMessageToSign = (selected, formVals) => {
	const signingMessageName = selected.name
	const signingPayload = formVals.properties
	const messageToSign = `${signingMessageName} Attestation

Metadata:
       ${generatePayloadString(signingPayload)}`

	return messageToSign
}

export const generateCollectionMessageToSign = (
	formVals: PinnedMetadataProperties,
) => {
	const signingPayload = formVals.properties
	const messageToSign = `Collection Attestation

Metadata:
       ${generatePayloadString(signingPayload)}`

	return messageToSign
}

export const generateMessageToSign = (
	nft,
	collection,
	selected,
	countersignEntry,
	formVals,
) => {
	const getNFTInfo = () => {
		if (
			countersignEntry &&
			(countersignEntry.template.slug === 'collection' ||
				countersignEntry.template.slug == 'rollup')
		) {
			return ''
		} else {
			return `
${
	nft && nft.chain && nft.chain !== ''
		? nft.chain === 'solana'
			? 'Token Program: '
			: 'Contract Address: '
		: ''
}${nft.contract.address}
${nft && nft.chain && nft.chain !== '' ? (nft.chain === 'solana' ? 'Token Address: ' : 'TokenID: ') : ''}${nft.tokenId}
`
		}
	}

	const getCollectionInfo = () => {
		if (countersignEntry && countersignEntry.template.slug === 'collection') {
			return ''
		} else {
			return `
${
	collection &&
	collection.references &&
	collection.references.attestationIPFSCID !== '' &&
	'Collection'
}: ${collection.references.attestationIPFSCID}`
		}
	}

	const signingMessageName = selected.name
	const signingPayload =
		countersignEntry && countersignEntry.properties
			? countersignEntry.properties
			: formVals.properties
	const secondSigningPayload = formVals.properties
	const ipfsMetadata = formVals.references.metadataIPFSCID

	if (countersignEntry && countersignEntry.properties) {
		const messageToSign = `${signingMessageName} ${selected.name === 'Revoke' || selected.name === 'Countersign' ? `${selected.name === 'Countersign' ? `for ${countersignEntry.template.name}` : `${countersignEntry.template.name}${countersignEntry.originalReference ? ` of ${countersignEntry.originalReference.template.name}` : ''}`}` : 'Attestation'}
${nft ? getNFTInfo() : ''}
${collection ? getCollectionInfo() : ''}
Metadata CID: ${ipfsMetadata}
${countersignEntry && countersignEntry.references && countersignEntry.references.metadataIPFSCID ? `Original Metadata CID: ${countersignEntry.references.metadataIPFSCID}` : ''}
${countersignEntry && countersignEntry.references && countersignEntry.references.attestationIPFSCID ? `Original Attestation CID: ${countersignEntry.references.attestationIPFSCID}` : ''}

${
	countersignEntry
		? `Metadata:\

        ${generatePayloadString(secondSigningPayload)}
`
		: ''
}
${countersignEntry ? 'Original Metadata:' : 'Metadata:'}
        ${generatePayloadString(signingPayload, true)}
`
		return messageToSign
	} else {
		const messageToSign = `${signingMessageName} ${selected.name === 'Revoke' || selected.name === 'Countersign' ? `Attestation for ${countersignEntry.template.name}` : nft ? 'Attestation for NFT' : collection ? 'Attestation for Collection' : ''}
${nft ? getNFTInfo() : collection ? getCollectionInfo() : ''}
Metadata CID: ${ipfsMetadata}

${'Metadata:'}
        ${generatePayloadString(signingPayload)}
`
		return messageToSign
	}
}

export const generateFormEntries = ({
	template,
	address,
	message = '',
	signature = '',
	ipfsCID,
	arweaveTxId,
	chain,
	tokenProgram,
	tokenAddress,
	contractAddress,
	tokenId,
	countersignEntry,
	formVals = [],
	isCountersignRequired,
	isArtistInitiated,
}) => {
	let referenceType = ''
	if (template.slug === 'revoke') {
		referenceType = 'Revoke'
	} else if (template.slug === 'countersign') {
		referenceType = 'Countersign'
	} else {
		referenceType = 'Attestation'
	}
	let iterableFormEntries = formVals

	const getReferencesEntry = () => {
		if (template.slug === 'rollup') {
			return { type: 'Rollup' }
		} else if (
			template.slug === 'get' &&
			countersignEntry &&
			countersignEntry?.template.slug === 'collection'
		) {
			//@ts-ignore
			return { type: 'Attestation', nft: countersignEntry.properties.nfts }
		} else {
			return {
				chain: {
					name: chain,
					id: chain ? chainIDMapping[chain] : 'ETH',
				},
				nft: {
					contractAddress: contractAddress,
					tokenId: tokenId,
				},
				type: 'Attestation',
			}
		}
	}

	const referencesEntry = getReferencesEntry()
	const formEntries = {
		createdAt: new Date(),
		template: {
			name: template.name,
			slug: template.slug,
			version: template.version,
		},
		address,
		message,
		signature,
		...(countersignEntry &&
			countersignEntry.properties && {
				originalReference: {
					metadataIPFSCID: countersignEntry.references.metadataIPFSCID,
					...(countersignEntry.references.attestationIPFSCID && {
						attestationIPFSCID: countersignEntry.references.attestationIPFSCID,
					}),
					...(countersignEntry.message && {
						message: countersignEntry.message,
					}),
					address: countersignEntry.address,
					...(countersignEntry.signature && {
						signature: countersignEntry.signature,
					}),
					uid: countersignEntry.uid,
					...(countersignEntry.createdAt && {
						createdAt: countersignEntry.createdAt,
					}),
					...(countersignEntry.properties.countersignRequired && {
						countersignRequired:
							countersignEntry.properties.countersignRequired,
					}),
					...(countersignEntry.properties.countersignStatus && {
						countersignStatus: countersignEntry.properties.countersignStatus,
					}),
					...(countersignEntry.properties.artistInitiated && {
						countersigningAddress: countersignEntry.properties.artistInitiated
							? countersignEntry.properties.receiverAddress
							: countersignEntry.properties.ownerAddress,
					}),
					...(countersignEntry.properties.artistInitiated === undefined &&
						countersignEntry.properties.receiverAddress && {
							countersigningAddress:
								countersignEntry.properties.receiverAddress,
						}),
					properties: countersignEntry.properties,
					type: 'Single',
					template: {
						name: countersignEntry.template.name,
						slug: countersignEntry.template.slug,
						version: countersignEntry.template.version,
					},
				},
			}),
		references: {
			type: referenceType,
			metadataIPFSCID: ipfsCID,
			metadataArweaveTxId: arweaveTxId,
			entry: referencesEntry,
		},
		properties: {},
	}

	for (const pair of iterableFormEntries) {
		const key = pair[0]
		// TODO: better way to filter out unneeded values
		if (
			[
				'Metadata Type',
				'Contract Address',
				'Token ID',
				'Chain',
				'User Address',
				'User Signature',
				'Image Web2 URL',
			].indexOf(key) < 0
		) {
			let value = fieldMapping[key]
			if (value === undefined) {
				value = key
			}
			let currentValue = pair[1]
			// if (value !== "Contract Address" && value.indexOf("Address") > -1) {
			//     currentValue =
			//         chain === "solana" ? currentValue : currentValue.toLowerCase();
			// }
			// if (value.indexOf("exhibitionWallet") > -1) {
			//     currentValue =
			//         chain === "solana" ? currentValue : currentValue.toLowerCase();
			// }
			if (value.indexOf('receiverAddress') > -1) {
				currentValue =
					chain === 'solana' ? currentValue : currentValue.toLowerCase()
			}
			if (value.indexOf('ownerAddress') > -1) {
				currentValue =
					chain === 'solana' ? currentValue : currentValue.toLowerCase()
			}
			if (currentValue !== '') {
				formEntries.properties[value] = currentValue
			}
			if (value.indexOf('countersignRequired') > -1) {
				// if (value.indexOf("isOptionalCountersignRequired") > -1) {
				//     formEntries.properties.countersignRequired = isCountersignRequired;
				// } else {
				formEntries.properties.countersignRequired = isCountersignRequired
			}
			if (value.indexOf('artistInitiated') > -1) {
				formEntries.properties.artistInitiated = isArtistInitiated
			}

			// if (value.indexOf("lendeeAddress") > -1) {
			//     currentValue =
			//         chain === "solana" ? currentValue : currentValue.toLowerCase();
			// }
			// if (value.indexOf("ownerWallet") > -1) {
			//     currentValue =
			//         chain === "solana" ? currentValue : currentValue.toLowerCase();
			// }
		}
	}
	if (formEntries.properties.isOptionalCountersignRequired) {
		delete formEntries.properties.isOptionalCountersignRequired
	}
	if (formEntries.properties.isArtistInitiated) {
		delete formEntries.properties.isArtistInitiated
	}
	if (!template.countersign) {
		delete formEntries.properties.countersignRequired
	}

	return formEntries
}

export const mapDraftData = (
	setPinData: (data: PinnedMetadataProperties) => void,
	data: PinnedMetadataProperties,
) => {
	//@ts-ignore
	if (data.references.entry) {
		setPinData(data)
		return
	}
	let draftData: PinnedMetadataProperties = {
		...data,
		references: {
			//@ts-ignore
			entry: { ...data.references },
			metadataIPFSCID: data.metadataIPFSCID,
			metadataArweaveTxId: data.arweaveTxId,
		},
	}
	delete draftData.arweaveTxId
	//@ts-ignore
	delete draftData.metadataIPFSCID
	delete draftData.isSigned
	delete draftData.nftCollection
	delete draftData.nftName
	delete draftData.nftImage
	setPinData(draftData)
}

// Check if user is authed first
// TODO: add countersign support
// TODO: add validation checks
export const mapPinData = ({
	selectedForm,
	address,
	userId,
	data,
	draftCollectionUid,
}: {
	selectedForm: { name: string; slug: string; version: string }
	address: string
	userId: string
	data: MetadataProperties
	draftCollectionUid?: string
}) => {
	// Map NFT
	const mapNFTDataReferences = (nfts: CollectionNFTInputType[]) => {
		const collectionReference: CollectionNFTReference = {}
		nfts.forEach(nft => {
			const {
				type,
				chain,
				contract,
				tokenStart,
				tokenEnd,
				tokenIDs,
				inputSelector,
				marketplace,
				marketplaceURL,
				name,
				total,
				entries,
			} = nft
			// Handle Adding Smart Contract Range Entry
			if (type === 'smartContractRange') {
				if (collectionReference.smartContractRange) {
					// Check if chain exists
					if (collectionReference.smartContractRange[chain]) {
						const chainRangeArray =
							collectionReference.smartContractRange[chain]
						const isContractInChainRangeArray = chainRangeArray.find(
							rangeEntry => rangeEntry.contract === contract,
						)
						// Check if contract exists
						if (isContractInChainRangeArray) {
							for (let i = 0; i < chainRangeArray.length; i++) {
								const chainRangeEntry = chainRangeArray[i]
								if (chainRangeEntry.contract === contract) {
									collectionReference.smartContractRange[chain][i].ranges.push({
										tokenStart,
										tokenEnd,
									})
								}
							}
							// Add contract if it doesn't exists
						} else {
							collectionReference.smartContractRange[chain].push({
								contract,
								ranges: [{ tokenStart, tokenEnd }],
							})
						}
						// add chain if it doesn't exist
					} else {
						collectionReference.smartContractRange[chain] = [
							{ contract, ranges: [{ tokenStart, tokenEnd }] },
						]
					}
				} else {
					// add type if it doesn't exist
					collectionReference.smartContractRange = {
						[chain]: [{ contract, ranges: [{ tokenStart, tokenEnd }] }],
					}
				}
			} else if (type === 'smartContractIDs') {
				if (collectionReference.smartContractIDs) {
					// Check if chain exists
					if (collectionReference.smartContractIDs[chain]) {
						const chainTokenIDArray =
							collectionReference.smartContractIDs[chain]
						const isContractInchainTokenIDArray = chainTokenIDArray.find(
							listEntry => listEntry.contract === contract,
						)
						// Check if contract exists
						if (isContractInchainTokenIDArray) {
							// collectionReference.smartContractIDs[chain][contract].tokenIDs.push(tokenID)
							for (let i = 0; i < chainTokenIDArray.length; i++) {
								const chainTokenIDEntry = chainTokenIDArray[i]
								const chainTokenIDEntryContract = chainTokenIDEntry.contract

								if (chainTokenIDEntryContract === contract) {
									for (let j = 0; j < tokenIDs.length; j++) {
										const newTokenID = tokenIDs[j]
										if (
											!collectionReference.smartContractIDs[chain][
												i
											].tokenIDs.includes(newTokenID)
										) {
											collectionReference.smartContractIDs[chain][
												i
											].tokenIDs.push(newTokenID)
										}
									}
									collectionReference.smartContractIDs[chain][i].tokenIDs = [
										...collectionReference.smartContractIDs[chain][i].tokenIDs,
									].sort((a, b) => {
										if (Number(a) < Number(b)) {
											return -1
										} else if (Number(a) > Number(b)) {
											return 1
										} else {
											return 0
										}
									})
								}
							}
							// Add contract if it doesn't exists
						} else {
							collectionReference.smartContractIDs[chain].push({
								contract,
								tokenIDs: tokenIDs,
							})
						}
						// add chain if it doesn't exist
					} else {
						collectionReference.smartContractIDs[chain] = [
							{ contract, tokenIDs: tokenIDs },
						]
					}
				} else {
					// add type if it doesn't exist
					collectionReference.smartContractIDs = {
						[chain]: [{ contract, tokenIDs: tokenIDs }],
					}
				}
			} else if (type === 'smartContractFull') {
				if (collectionReference.smartContractFull) {
					// Check if chain exists
					if (collectionReference.smartContractFull[chain]) {
						collectionReference.smartContractFull[chain].push(contract)
						// add chain if it doesn't exist
					} else {
						collectionReference.smartContractFull[chain] = [contract]
					}
				} else {
					collectionReference.smartContractFull = {}
					collectionReference.smartContractFull[chain] = [contract]
				}
			} else {
				// handle other input types
				alert(
					`We need to add the following input type in mapNFTDataReferences in mintUtils - ${type}`,
				)
			}
		})
		return collectionReference
	}

	// @ts-ignore
	const mappedNFTDataReferences = data?.nfts
		? mapNFTDataReferences(data.nfts)
		: {}
	let modifiedData = { ...data }
	// @ts-ignore
	if (selectedForm.slug === 'collection' && modifiedData.nfts) {
		// @ts-ignore
		delete modifiedData.nfts
	}

	let pinData: PinnedMetadataProperties = {
		//@ts-ignore
		createdAt: new Date().toISOString(),
		address: address,
		// // TODO: store and retrieve afAddress from process.env or server
		// ...(selectedForm.slug === 'rollup' && {
		// 	afAddress: '0x00AF',
		// }),
		template: {
			name: selectedForm.name,
			slug: selectedForm.slug,
			version: selectedForm.version,
		},
		references: {
			// @ts-ignore
			type: selectedForm.name,
			// @ts-ignore
			...(data.nfts && { nft: mappedNFTDataReferences }),
		},
		properties: {
			...modifiedData,
		} as MetadataProperties,
		userId: userId,
		...(draftCollectionUid && { draftCollectionUid }),
	}
	return pinData
}

export const getLoadingCollectionEntryCounts = (
	pinData: PinnedMetadataProperties,
	isAwaiting: boolean,
) => {
	let chainContractTokenCounts: {
		chain: string
		contract: string
		tokenCount: number
		isAwaiting: boolean
	}[] = []
	const referenceNFTs = pinData.references.nft
		? pinData.references.nft
		: pinData.references.entry && pinData.references.entry.nft
			? pinData.references.entry.nft
			: {}
	if (Object.entries(referenceNFTs).length === 0) {
		return chainContractTokenCounts
	}
	type CollectionEntriesType = [
		key: CollectionNFTReferenceKey,
		{ value: CollectionNFTReferenceValue },
	][]
	const CollectionEntries: CollectionEntriesType = Object.entries(referenceNFTs)

	const updateChainContractTokenCounts = ({
		chain,
		contract,
		count,
		awaiting,
	}: {
		chain: string
		contract: string
		count: number
		awaiting: boolean
	}) => {
		// check if chain and contract exist
		// if yes, update count
		// if no, add value
		let isChainContractInArray = false
		for (let i = 0; i < chainContractTokenCounts.length; i++) {
			const entry = chainContractTokenCounts[i]
			if (entry.chain === chain && entry.contract == contract) {
				isChainContractInArray = true
				chainContractTokenCounts[i].tokenCount += count
				chainContractTokenCounts[i].isAwaiting = awaiting
			}
		}
		if (isChainContractInArray == false) {
			chainContractTokenCounts.push({
				chain,
				contract,
				tokenCount: count,
				isAwaiting: awaiting,
			})
		}
	}

	const parseFullContractEntries = (
		inputEntry: SmartConractFullValue,
		isAwaiting: boolean,
	) => {
		for (const chain in inputEntry) {
			const chainEntry = inputEntry[chain]
			for (let i = 0; i < chainEntry.length; i++) {
				const contract = chainEntry[i]
				let count = 0
				updateChainContractTokenCounts({
					chain,
					contract,
					count: count,
					awaiting: isAwaiting,
				})
			}
		}
	}

	const parseCollectionEntries = (
		CollectionEntries: CollectionEntriesType,
		isAwaiting,
	) => {
		for (let i = 0; i < CollectionEntries.length; i++) {
			const [key, value] = CollectionEntries[i]

			if (key === 'smartContractRange') {
				const inputEntry = referenceNFTs[key]
				if (inputEntry) {
					for (const chain in inputEntry) {
						const chainEntries = inputEntry[chain]
						for (let i = 0; i < chainEntries.length; i++) {
							const chainEntry = chainEntries[i]
							chainEntry.ranges &&
								chainEntry.ranges.forEach(range => {
									let count =
										Number(range.tokenEnd) - Number(range.tokenStart) + 1
									updateChainContractTokenCounts({
										chain,
										contract: chainEntry.contract,
										count,
										awaiting: false,
									})
								})
						}
					}
				}
			} else if (key === 'smartContractIDs') {
				const inputEntry = referenceNFTs[key]
				if (inputEntry) {
					for (const chain in inputEntry) {
						const chainEntries = inputEntry[chain]
						for (let i = 0; i < chainEntries.length; i++) {
							const contractEntry = chainEntries[i]
							// @ts-ignore
							updateChainContractTokenCounts({
								chain,
								contract: contractEntry.contract,
								count: contractEntry.tokenIDs.length,
								awaiting: false,
							})
						}
					}
				}
			} else if (key === 'smartContractFull') {
				const inputEntry = referenceNFTs[key]
				if (inputEntry) {
					parseFullContractEntries(inputEntry, isAwaiting)
				}
			}
		}
	}
	parseCollectionEntries(CollectionEntries, isAwaiting)
	return chainContractTokenCounts
}

export const getCollectionEntryCounts = async ({
	pinData,
}: {
	pinData: PinnedMetadataProperties
}) => {
	let success = false
	if (!pinData) return { success }
	let clonedPin = { ...pinData }
	try {
		const requestResponse = await fetch('/getCollectionEntryCountsAPI', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ pinData }),
		})
		const jsonResponse = (await requestResponse.json()) as {
			success: boolean
			error?: string
			collectionEntries?: {
				chain: string
				contract: string
				tokenCount: number
				isAwaiting?: boolean
			}[]
		}

		if (jsonResponse.success === true) {
			if (jsonResponse.collectionEntries) {
				clonedPin.collectionEntries = jsonResponse.collectionEntries
				success = true
			}
		} else {
			console.error('JSON RESPONSE UNSUCCESSFUL', jsonResponse)
		}
	} catch (e) {
		console.error('PINNING ERROR MINT UTILS', e)
	} finally {
		return { pinData: clonedPin, success }
	}
}

export const handlePin = async ({
	pinData,
}: {
	pinData: PinnedMetadataProperties
}) => {
	if (!pinData) return
	const clonedPin = { ...pinData }
	try {
		const pinResponse = await fetch('/pinMetadataAPI', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ pinData }),
		})
		const jsonResponse = (await pinResponse.json()) as {
			success: boolean
			ipfsCID: string
			arweaveTxId: string
			GroupNFTsCID?: string
			attestationUid?: string
		}

		if (jsonResponse.success === true) {
			if (jsonResponse.GroupNFTsCID) {
				clonedPin.properties = {
					...clonedPin.properties,
					GroupNFTsCID: jsonResponse.GroupNFTsCID,
				}
			}
			const newPinData = {
				...clonedPin,
				references: {
					...clonedPin.references,
					metadataIPFSCID: jsonResponse.ipfsCID,
					...(jsonResponse.arweaveTxId && {
						metadataArweaveTxId: jsonResponse.arweaveTxId,
					}),
				},
			}
			return {
				pinnedData: newPinData,
				draftAttestationUid: jsonResponse.attestationUid,
			}
		} else {
			return undefined
		}
	} catch (e) {
		console.error('PINNING ERROR MINT UTILS', e)
		return undefined
	}
}
